import React from "react";
import { connect } from "react-redux";
import { Container } from "semantic-ui-react";
import PropTypes from "prop-types";
import RegisterIdentificationForm from "./form/RegisterIdentificationForm";
import RegisterValidationForm from "./form/RegisterValidationForm";
import RegisterConfirmationForm from "./form/RegisterConfirmationForm";
import {
  REGISTER_FASE_IDENTIFICATION,
  REGISTER_FASE_VALIDATION,
  REGISTER_FASE_CONFIRMATION,
} from "../../../app/infrastructure/appConstants";
import RegisterCompleted from "./form/RegisterCompleted";

const mapState = (state) => ({
  fase: state.registerUser.fase,
});

const RegisterPage = ({ fase }) => {
  return (
    <Container className="containerFormRegister">
      {fase === REGISTER_FASE_IDENTIFICATION ? (
        <RegisterIdentificationForm />
      ) : fase === REGISTER_FASE_VALIDATION ? (
        <RegisterValidationForm />
      ) : fase === REGISTER_FASE_CONFIRMATION ? (
        <RegisterConfirmationForm />
      ) : (
        <RegisterCompleted />
      )}
    </Container>
  );
};

RegisterPage.propTypes = {
  fase: PropTypes.number.isRequired,
};

export default connect(mapState, null)(RegisterPage);
